import loginApi from '../api/services/loginServices';
import { userAtom, defaultUser } from '../atoms/userAtom';
import { setRecoil } from 'recoil-nexus';

const services = {};

services.login = user => {
  return loginApi.login(user.userName, user.password, user.client.id, user.mfaToken);
};

services.quit = () => {
  setRecoil(userAtom, { ...defaultUser });
};

export default services;